
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const mira: Operator = {
	id: 'mira',
	name: 'Mira',
	role: 'Defender',
	org: 'GEO',
	squad: 'VIPERSTRIKE',
	ratings: {
		health: 3,
		speed: 1,
		difficulty: 3
	},
	meta: {
		gender: 'f',
		country: 'es',
		season: 'Y2S1',
		height: 165,
		weight: 60,
		price: {
			renown: 10000,
			r6credits: 240
		}
	},
	bio: {
		real_name: 'Elena Maria Alvarez del Manzano',
		birthplace: 'Madrid, Spain'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z" style="fill:#673081"></path><path d="M45 114.75h260v119H45z"></path><path d="M32 121.25h286v106H32z" style="fill:#fff"></path><path d="M39 128h272v92.5H39z"></path><path d="m131.429 133.75-65.894 81h63.009l65.893-81zm141.368 0-65.894 81h12.79l65.894-81zm-54.061 0-65.894 81h29.763l65.893-81z" style="fill:#fff"></path><path d="M73.389 105.339c-5.266 0-9.55 4.284-9.55 9.55s4.284 9.55 9.55 9.55 9.55-4.284 9.55-9.55-4.284-9.55-9.55-9.55"></path><circle cx="73.389" cy="114.889" r="5" style="fill:#fff"></circle><path d="M175.194 105.339c-5.266 0-9.55 4.284-9.55 9.55s4.284 9.55 9.55 9.55 9.55-4.284 9.55-9.55-4.284-9.55-9.55-9.55"></path><circle cx="175.194" cy="114.889" r="5" style="fill:#fff"></circle><path d="M277 105.339c-5.266 0-9.55 4.284-9.55 9.55s4.284 9.55 9.55 9.55 9.55-4.284 9.55-9.55-4.284-9.55-9.55-9.55"></path><circle cx="277" cy="114.889" r="5" style="fill:#fff"></circle><path d="M73.389 223.45c-5.266 0-9.55 4.284-9.55 9.55s4.284 9.55 9.55 9.55 9.55-4.284 9.55-9.55-4.284-9.55-9.55-9.55"></path><circle cx="73.389" cy="233" r="5" style="fill:#fff"></circle><path d="M175.194 223.45c-5.266 0-9.55 4.284-9.55 9.55s4.284 9.55 9.55 9.55 9.55-4.284 9.55-9.55-4.284-9.55-9.55-9.55"></path><circle cx="175.194" cy="233" r="5" style="fill:#fff"></circle><path d="M277 223.45c-5.266 0-9.55 4.284-9.55 9.55s4.284 9.55 9.55 9.55 9.55-4.284 9.55-9.55-4.284-9.55-9.55-9.55"></path><circle cx="277" cy="233" r="5" style="fill:#fff"></circle></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-mira'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
